import styled from "styled-components";
import { IMember } from "./teamMembers";

interface TeamMemberProps {
  member: IMember;
}

const TeamMemberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  max-width: 238px;

  h6 {
    font-size: 30px;
    line-height: 64px;
    font-weight: 700;
    margin-bottom: 17px;
  }

  span {
    font-family: Neue-Haas, sans-serif;
    font-weight: 400;
    size: 16px;
    color: #cecfd0;
  }

  @media ${({ theme }) => theme.mediaQueries.bellowTabletProtrait} {
    h6 {
      font-size: 20px;
      line-height: 33px;
      margin-bottom: 4px;
    }
    span {
      size: 14px;
    }
  }
`;

const MemberImage = styled.img`
  width: 238px;
  margin: 0 auto;

  @media ${({ theme }) => theme.mediaQueries.bellowTabletProtrait} {
    width: 135px;
  }
`;

const TeamMember: React.FC<TeamMemberProps> = (props) => {
  const { member } = props;
  return (
    <TeamMemberWrapper>
      <MemberImage src={member.img.src} alt={member.img.alt} />
      <h6>{member.name}</h6>
      <span>{member.position}</span>
    </TeamMemberWrapper>
  );
};

export default TeamMember;
